import type { Service } from './service'

export class ServiceConsumptionItem {
    serviceConsumptionItemId?: string
    serviceId?: string
    consumableServiceId: string
    consumable?: Service // hidratado no frontend a partir de consumableServiceId — não vai pro backend
    quantity: number
    createdAt?: Date
    updatedAt?: Date
}
